import { styled } from "@mui/material"
import { BORDER_RADIUS } from "../utils/theme"

export const PageContainer = styled("div")({
  display: "grid",
  gridTemplateRows: "auto 1fr",
  borderRadius: BORDER_RADIUS,
  marginBottom: 100, // makes sure content on mobile viewports doesn't get blocked by the help button
})
